import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_DocType = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(-1);
    const _Onchange = (value) => {
        props.onChange(value == null ? -1 : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id) {
            var RequestOptions = {
                data: {
                    'Title': '',
                    'DocSettingUsedIn': -1,
                    'DocSettingType': -1,
                    'IsActive': 1
                },
                url: General.ApiRoute() + "/Account_DocType/Search",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(result => {
                        var tmp = []

                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                Id: result.data[i].id,
                                Title: result.data[i].title,

                            })
                            if (result.data[i].id == id) {
                                props.onChange(id, result.data[i].title)
                            }
                        }
                        setList(tmp)
                        setId(id)

                    })
                    .catch((error) => {
                        console.dir(error)
                    })
            )
        },

    }))



    return (
        <rsuite.SelectPicker


            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => _Onchange(value)}

        />

    )
});

export default Drp_DocType;